import { getAuthAxiosBackend } from "../helpers/axios"
// import genderStatisticsData from './7 - 1.json'
// import ageStatisticsData from './7 - 2.json'
// import maritalStatisticsData from './7 - 3.json'
// import educationStatisticsData from './7 - 4.json'

class StstisticServices{
    
    getCountsStatistics(data = {}){
        return getAuthAxiosBackend().get('Security/User/user-types-statistics', {params: data})
    }

    getUsersByRegions(data = {}){
        return getAuthAxiosBackend().post('Security/User/users/count', data)
    }

    getPersonTypesByGovernorate(data = {}){
        return getAuthAxiosBackend().get('Person/Person_Statistics_By_Governorate_And_Type', {params: data})
    }

    getMaritalByPersonTypesAndGovernorate(data = {}){
        return getAuthAxiosBackend().get('Person/statistics/marital', {params: data})
        // return Promise.resolve({ data: maritalStatisticsData })
    }

    getEducationByPersonTypesAndGovernorate(data = {}){
        return getAuthAxiosBackend().get('Person/statistics/education', {params: data})
        // return Promise.resolve({ data: educationStatisticsData })
    }

    getAgeByPersonTypesAndGovernorate(data = {}){
        return getAuthAxiosBackend().get('Person/statistics/age', {params: data})
        // return Promise.resolve({ data: ageStatisticsData })
    }
    
    getGenderByPersonTypesAndGovernorate(data = {}){
        return getAuthAxiosBackend().get('Person/statistics/gender', {params: data})
        // return Promise.resolve({ data: genderStatisticsData })
    }
}

export default new StstisticServices()